module.exports = __webpack_public_path__ + "static/media/buenos_aires.64f3934c.jpg";